// actions
const SET = "zatcaInvoices/SET";
const SET_SEARCH_TEXT = "zatcaInvoices/SET_SEARCH_TEXT";
const SET_SELECTED = "zatcaInvoices/SET_SELECTED";
const SET_ZATCA_INVOICES_STATS = "zatcaInvoices/SET_ZATCA_INVOICES_STATS";
const SET_ZATCA_CREDIT_NOTES_STATS = "zatcaInvoices/SET_ZATCA_CREDIT_NOTES_STATS";

const CHANGE_LIMIT = "zatcaInvoices/CHANGE_LIMIT";
const NEXT_ACTION = "zatcaInvoices/NEXT_ACTION";
const SET_NEXT_TOKEN = "zatcaInvoices/SET_NEXT_TOKEN";
const SET_PREVIOUS_TOKENS = "zatcaInvoices/SET_PREVIOUS_TOKENS";
const SET_FILTER = "zatcaInvoices/SET_FILTER";

const DEFAULT_STATE = {
  listing: [],
  zatcaInvoicesStats: [],
  zatcaCreditNotesStats: [],
  searchText: "",
  selected: null,

  limit: 10,
  nextToken: null,
  previousTokens: [],
  filter: []
};

// reducer
const reducer = (state = DEFAULT_STATE, action: any = {}) => {
  switch (action.type) {
    case SET:
      return Object.assign({}, state, { listing: action.listing });
    case SET_ZATCA_INVOICES_STATS:
      return Object.assign({}, state, { zatcaInvoicesStats: action.listing });
    case SET_ZATCA_CREDIT_NOTES_STATS:
      return Object.assign({}, state, { zatcaCreditNotesStats: action.listing });
    case SET_FILTER:
      return Object.assign({}, state, { filter: action.id });

    case SET_SEARCH_TEXT:
      return Object.assign({}, state, { searchText: action.searchText });
    case SET_SELECTED:
      return Object.assign({}, state, { selected: action.model });

    case SET_NEXT_TOKEN:
      return Object.assign({}, state, { nextToken: action.nextToken });
    case SET_PREVIOUS_TOKENS:
      return Object.assign({}, state, {
        previousTokens: action.previousTokens,
      });

    case CHANGE_LIMIT:
      return Object.assign({}, state, {
        limit: action.limit,
        nextToken: action.nextToken,
        nextNextToken: action.nextNextToken,
        previousTokens: action.previousTokens,
      });

    case NEXT_ACTION:
      return Object.assign({}, state, {
        nextToken: action.nextToken,
        previousTokens: action.previousTokens,
      });

    default:
      return state;
  }
};

export default reducer;

// action creators
export const setFilter = (id: any) => ({ id, type: SET_FILTER });

export const setListing = (listing: any[]) => ({ listing, type: SET });

export const setListingZatcaInvoicesStats = (listing: any[]) => ({
  listing,
  type: SET_ZATCA_INVOICES_STATS,
});

export const setListingZatcaCreditNotesStats = (listing: any[]) => ({
  listing,
  type: SET_ZATCA_CREDIT_NOTES_STATS,
});

export const setSearchText = (searchText: string) => ({
  searchText,
  type: SET_SEARCH_TEXT,
});

export const setSelected = (model: any) => ({ model, type: SET_SELECTED });

export const changeLimit = (limit: any) => ({
  limit: limit,
  nextToken: null,
  nextNextToken: null,
  previousTokens: [],

  type: CHANGE_LIMIT,
});

export const nextAction = (nextToken: any, previousTokens: any[]) => ({
  nextToken: nextToken,
  previousTokens: previousTokens ? [...previousTokens, nextToken] : [nextToken],

  type: NEXT_ACTION,
});

export const setNextToken = (nextToken: any) => ({
  nextToken,
  type: SET_NEXT_TOKEN,
});

export const setPreviousToken = (previousTokens: any) => ({
  previousTokens,
  type: SET_PREVIOUS_TOKENS,
});
